export const constants = {
	symbols : {
		x: 'X',
		o: 'O',
		xo: 'XO'
	},
	players: {
		human: 'Human',
		computer: 'Computer'
	},
	messages: {
		newGameAfterWin: ' won. Start a new game!',
		startGame: 'Start a new game!',
		drawHeadLine: 'It\'s a Draw',
		turn: ' Turn',
		won: 'WON',
		draw: 'DRAW'
	}
};
			  